import type { NavigateFunction } from 'react-router-dom';

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigate: NavigateFunction): void => {
	globalNavigate = navigate;
};

export const getGlobalNavigate = (): NavigateFunction | null => {
	return globalNavigate;
};
